import React from 'react';
import BlurFade from '../primitives/BlurFade';
import { Section } from '../layout/Section';
import { Container } from '../layout/Container';
import { Eyebrow } from '../layout/typography';

/**
 * QuoteBlock — single hero-sized customer quote, like clip-shade.de's testimonial.
 */
export default function QuoteBlock({
  id, testId, tone = 'sand', rhythm = 'grand',
  eyebrow, quote, author, role,
}) {
  return (
    <Section id={id} data-testid={testId} tone={tone} rhythm={rhythm}>
      <Container variant="narrow" className="text-center">
        {eyebrow && <BlurFade><Eyebrow className="mb-9">{eyebrow}</Eyebrow></BlurFade>}
        <BlurFade delay={0.05}>
          <p className="font-display text-[#1F1D1A] text-[28px] sm:text-[40px] lg:text-[52px] leading-[1.15] tracking-tight">
            <span className="text-[#F26B1A] mr-2" aria-hidden="true">«</span>
            {quote}
            <span className="text-[#F26B1A] ml-2" aria-hidden="true">»</span>
          </p>
        </BlurFade>
        <BlurFade delay={0.15}>
          <div className="mt-10 inline-flex flex-col items-center gap-1">
            <span className="text-[14px] font-medium text-[#1F1D1A]">{author}</span>
            {role && <span className="text-[12px] uppercase tracking-[0.18em] text-[#F26B1A]">{role}</span>}
          </div>
        </BlurFade>
      </Container>
    </Section>
  );
}
